import { Injectable } from '@angular/core';
import { PageService } from '../services/page.service'
import { UserRepository } from '../repositories/user.repository';
import { Constants } from '../constants/constants';
import { EventEmitter } from '@angular/core';
import { IUserFetchCriteriaModel } from '../entities-api/IUserFetchCriteriaModel';
import { IUserProfileDataModel } from '../entities-api/IUserProfileDataModel';
import { IGlobalEmployeeInfoModel } from '../entities-api/IGlobalEmployeeInfoModel';
import { IGlobalEmployeeOverrideModel } from '../entities-api/IGlobalEmployeeOverrideModel';
import { IGlobalEmployeeDetailGridDataModel } from '../entities-api/IGlobalEmployeeDetailGridDataModel';
import { IGlobalEmployeeDictionariesModel } from '../entities-api/IGlobalEmployeeDictionariesModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IBulkProfileModel } from '../entities-api/IBulkProfileModel';
import { IBulkProfileResultModel } from '../entities-api/IBulkProfileResultModel';
import { catchError, map } from 'rxjs/operators';
import { IAppcodeModel } from '../entities-api/IAppcodeModel';
import { IMfcodemodel } from '../entities-api/IMfcodemodel';
import { IContainerMappingDetailGridDataModel } from '../entities-api/IContainerMappingDetailGridDataModel';
import { IContainerMappingFetchCriteriaModel } from '../entities-api/IContainerMappingFetchCriteriaModel';
import { IGeocodemodel } from '../entities-api/IGeocodemodel';
import { IMfModel } from '../entities-api/IMfModel';
import { IBaseMappingFetchCriteriaModel } from '../entities-api/IBaseMappingFetchCriteriaModel';
import { IBaseMappingDetailGridDataModel } from '../entities-api/IBaseMappingDetailGridDataModel';


@Injectable()
export class UserService {
  constructor(
    private userRepository: UserRepository,
    private page: PageService,
    private http: HttpClient
  ) {
    this.init();
  }

  private currentUser: Promise<IGlobalEmployeeInfoModel> = null;
  private cachedGridDataModel: IGlobalEmployeeDetailGridDataModel;
  private cachedGridDataModelcontainer: IContainerMappingDetailGridDataModel;
  private cachedGridDataModelbase: IBaseMappingDetailGridDataModel;
  private Constants = Constants;
  showUpdates: boolean = false;
  bellIconClickedEvent: EventEmitter<{}> = new EventEmitter();
  usersImagesCache = {};
  filter = <IUserFetchCriteriaModel>{}
  filerconatinermapping = <IContainerMappingFetchCriteriaModel>{}
  filterbasemapping = <IBaseMappingFetchCriteriaModel>{}
  mfmodel = <IMfModel>{}

  private init(): void {
    //this.currentUser = this.userRepository.getCurrentUserAsync();
  }

  getCurrentUserAsync(): Promise<IGlobalEmployeeInfoModel> {
    return this.userRepository.getCurrentUserAsync();
  }
 
  getCurrentUserImage(id: string): Promise<XMLHttpRequest> {
    if (this.usersImagesCache[id] != null) {
      return this.usersImagesCache[id];
    }

    var promise = this.userRepository.getCurrentUserImage(id);
    this.usersImagesCache[id] = promise;

    return promise;
  }

  renewSession(): Promise<{}> {
    return this.userRepository.renewSession();
  }

  get gridDataModel(): IGlobalEmployeeDetailGridDataModel {
    return this.cachedGridDataModel;
  }

  getUsers = (pageIndex: number = 0): Promise<IGlobalEmployeeDetailGridDataModel> => {
    this.filter.TopRows = Constants.PagingConst.RecordsPerPage;
    pageIndex = this.page.currentPage;
    this.filter.SkipRows = pageIndex * Constants.PagingConst.RecordsPerPage;
    return this.userRepository.getUsers(this.removeEmptyFields(this.filter)).then(
      (data: IGlobalEmployeeDetailGridDataModel) => {
        this.cachedGridDataModel = data;
        return this.cachedGridDataModel;
      });
  }
  getDuplicateUsersSearch = (pageIndex: number = 0): Promise<IGlobalEmployeeDetailGridDataModel> => {
    this.filter.TopRows = Constants.PagingConst.RecordsPerPage;
    pageIndex = this.page.currentPage;
    this.filter.SkipRows = pageIndex * Constants.PagingConst.RecordsPerPage;
    return this.userRepository.getDuplicateUsersSearch(this.removeEmptyFields(this.filter)).then(
      (data: IGlobalEmployeeDetailGridDataModel) => {
        this.cachedGridDataModel = data;
        return this.cachedGridDataModel;
      });
  }
  getAPIUsers = (pageIndex: number = 0): Promise<IGlobalEmployeeDetailGridDataModel> => {
    this.filter.TopRows = Constants.PagingConst.RecordsPerPage;
    pageIndex = this.page.currentPage;
    this.filter.SkipRows = pageIndex * Constants.PagingConst.RecordsPerPage;
    return this.userRepository.getAPIUsers(this.removeEmptyFields(this.filter)).then(
      (data: IGlobalEmployeeDetailGridDataModel) => {
        this.cachedGridDataModel = data;
        return this.cachedGridDataModel;
      });
  }

  getDuplicateUsers = (pageIndex: number = 0): Promise<IGlobalEmployeeDetailGridDataModel> => {
    this.filter.TopRows = Constants.PagingConst.RecordsPerPage;
    pageIndex = this.page.currentPage;
    this.filter.SkipRows = pageIndex * Constants.PagingConst.RecordsPerPage;
    return this.userRepository.getDuplicateUsers(this.removeEmptyFields(this.filter)).then(
      (data: IGlobalEmployeeDetailGridDataModel) => {
        this.cachedGridDataModel = data;
        return this.cachedGridDataModel;
      });
  }

  syncUser(user, pageIndex: number = 0){
    this.filter = {...user}
    this.filter.TopRows = Constants.PagingConst.RecordsPerPage;
    pageIndex = this.page.currentPage;
    this.filter.SkipRows = pageIndex * Constants.PagingConst.RecordsPerPage;
    return this.userRepository.syncDuplicatedUsers(this.filter)
  }

  removeEmptyFields(filter: IUserFetchCriteriaModel): IUserFetchCriteriaModel {
    for (var prop in filter) {
      if (filter.hasOwnProperty(prop) && filter[prop] === "") {
        delete filter[prop];
      }
    }

    return filter;
  }
  removeEmptyFieldscontainermapping(filter: IContainerMappingFetchCriteriaModel): IContainerMappingFetchCriteriaModel {
    for (var prop in filter) {
      if (filter.hasOwnProperty(prop) && filter[prop] === "") {
        delete filter[prop];
      }
    }

    return filter;
  }
  getUser(id: number): Promise<IGlobalEmployeeDetailGridDataModel> {
    var filter: IUserFetchCriteriaModel = <IUserFetchCriteriaModel>{};
    filter.GlobalPersonId = id;
    return this.userRepository.getUsers(filter);
  }



  revertOverride(id: string): Promise<{}> {
    return this.userRepository.revertOverride(id);
  }

  getDictionaries(): Promise<IGlobalEmployeeDictionariesModel> {
    return this.userRepository.getDictionaries();
  }

  getOverrides(id: string): Promise<IGlobalEmployeeOverrideModel[]> {
    return this.userRepository.getOverrides(id);
  }

  create(user: IGlobalEmployeeOverrideModel): Promise<IGlobalEmployeeOverrideModel[]> {
    return this.userRepository.create(user);
  }
 
  createUserProfile(user: IGlobalEmployeeOverrideModel): Promise<boolean> {
    return this.userRepository.createUserProfile(user);
  }

  getUserProfile(id: string): Promise<IUserProfileDataModel> {
    return this.userRepository.getUserProfile(id);
  }

  export(): string {
    return "api/User/ExportModifiedAccounts";
  }

  bellIconClicked(): void {
    this.showUpdates = true;
    this.bellIconClickedEvent.emit(null);
  }

  getBellIconClickEmitter() {
    return this.bellIconClickedEvent;
  }

  getNewOpmUpdatesAvailable(): Promise<boolean> {
    return this.userRepository.getNewOpmUpdatesAvailable();
  }

  //getAccessForContainerMapping(): Promise<boolean> {
    //return this.userRepository.getAccessForContainerMapping();
  //}

  getWriteAccessData(): Promise<boolean> {
    return this.userRepository.getWriteAccessData();
  }
  getReadOnlyAccessData(): Promise<boolean> {
    return this.userRepository.getReadOnlyAccessData();
  }
  getDQGateAccessData(): Promise<boolean> {
    return this.userRepository.getDQGateAccessData();
  }
  resetNewOpmUpdatesAvailable(): Promise<{}> {
    return this.userRepository.resetNewOpmUpdatesAvailable();
  }

  upload(userlist: IBulkProfileModel): Promise<IBulkProfileResultModel[]> {
    return this.userRepository.createBulkUserProfile(userlist);
  } 
  
  GetExcelFile() {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Access-Control-Allow-Methods', 'GET, POST, PUT');
    return this.http.get(this.userRepository.downloadFile(), 
      { headers: headers }).pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  getCreateProfileAccessMasterdata(email: string): Promise<boolean> {
    return this.userRepository.getCreateProfileAccessMasterdata(email);
  }

  addProfileLogs(action: string): Promise<{}> {
    return this.userRepository.addProfileLogs(action);
  }
}
